export default "__VITE_ASSET__CQnZWpDd__"